function chartPath(values: number[], width: number, height: number, maximum: number) {
  if (values.length === 0) return "";
  return values.map((value, index) => {
    const x = values.length === 1 ? 0 : index * width / (values.length - 1);
    const y = height / 2 - value / maximum * (height / 2 - 12);
    return `${index === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`;
  }).join(" ");
}

function compact(value: number) {
  const absolute = Math.abs(value);
  if (absolute >= 1000) return `${(value / 1000).toFixed(1)}k`;
  return String(value);
}

export function AdvantageChart({ values, radiantName, direName, label }: { values: number[]; radiantName: string; direName: string; label: string }) {
  const width = 760;
  const height = 220;
  const maximum = Math.max(1000, ...values.map((value) => Math.abs(value)));
  const path = chartPath(values, width, height, maximum);
  const current = values.at(-1) ?? 0;
  return <section className="advantage-chart">
    <header><div><small>{label}</small><strong>{current >= 0 ? radiantName : direName} {compact(Math.abs(current))}</strong></div><span>Radiant advantage ↑ · Dire advantage ↓</span></header>
    {path ? <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={`${label} over time`} preserveAspectRatio="none">
      <defs><linearGradient id={`advantage-${label.replace(/\W/g, "")}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#7bcf82" /><stop offset=".49" stopColor="#d9e1e8" /><stop offset=".51" stopColor="#d9e1e8" /><stop offset="1" stopColor="#d16a59" /></linearGradient></defs>
      <line x1="0" y1={height / 2} x2={width} y2={height / 2} className="advantage-zero" />
      <path d={path} fill="none" stroke={`url(#advantage-${label.replace(/\W/g, "")})`} strokeWidth="4" vectorEffect="non-scaling-stroke" />
    </svg> : <p>Advantage timeline is not available for this game.</p>}
  </section>;
}
